import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import {
  DropdownDataState,
  reducer as dropdownDataReducer,
  initialDropdownDataState,
} from './App/Reducers/DropdownData';
import {
  FilterState,
  reducer as filterReducer,
  defaultFilterState,
} from './App/Reducers/FilterReducer';
import { AnyAction } from 'redux';
import thunk from 'redux-thunk';
import { signedInUserReducer } from '../src/reducers/signedInUserReducer';
import dashboardReducer from '../src/reducers/dashboardReducer';
import {
  reducer as userProfileReducer,
  initialUserProfileState,
} from '../src/reducers/userProfileReducer';
import actionReducer from '../src/reducers/actionReducer';
import viewReducer from '../src/reducers/viewReducer';
import workItemSubscriptionReducer from '../src/reducers/workItemSubscriptionsReducer';
import { loadWorkItems } from '../src/reducers/index';
import { UserContext } from './Models/UserProfile';
import bannerReducer from '../src/reducers/bannerMessageReducer';
import notificationsReducer from "../src/reducers/notificationsReducer"
import ratingReducer from "../src/reducers/RatingReducer"
import { MaaSCreationData } from './Models/UpdateWorkitem';
import { initialMaaSState, maaSreducer } from './reducers/MaaSReducer';
import languageMiddleware from '../src/Middleware/languageMiddleware'
import languageReducer from './reducers/languageReducer';
import { GPSInvestmentCreationData } from './GPSInvestments/Models/GPSInvestmentCreation';
import { gpsReducer, initialGPSInvetmentState } from './GPSInvestments/Reducers/GPSInvestmentReducer';
import { gpsManageListReducer, initialGPSManageListState } from './GPSInvestments/Reducers/PartnerTabelReducer';
import { GPSManageListModel } from './GPSInvestments/Models/GPSManageListModel';
import { reducer as vacTenantReducer } from '../src/reducers/vacTenantReducer';
import { reducer as featureFlagsReducer, initialFeatureFlagsState, FeatureFlagsState } from './reducers/featureFlagsReducer';
import navCollapsedReducer from './reducers/navCollapsedReducer';
import copilotReducer, { initialState as copilotInitialState } from './copilot-v2/store/copilotSlice';
import { copilotApi } from './copilot-v2/Store/copilotApi';
export interface StoreState {
  dropdownData: DropdownDataState;
  filter: FilterState;
  viewReducer: any;
  actionReducer: any;
  dashboardReducer: any;
  signedInUserReducer: any;
  loadWorkItems: any;
  userProfile: UserContext;
  bannerReducer: any;
  workItemSubscriptionReducer: any;
  notificationsReducer: any;
  ratingReducer: any;
  dashboardSplitMode: boolean;
  maaSCreationData: MaaSCreationData;
  languageReducer: any;
  gpsCreationData: GPSInvestmentCreationData;
  gpsManageListData: GPSManageListModel;
  selectedActionId: string;
  vacTenant: any;
  featureFlags: FeatureFlagsState;
  copilot: ReturnType<typeof copilotReducer>;
  [copilotApi.reducerPath]: ReturnType<typeof copilotApi.reducer>;
}

export const createMockStore = (): StoreState => {
  return {
    dropdownData: initialDropdownDataState,
    filter: defaultFilterState,
    actionReducer: {},
    dashboardReducer: {},
    signedInUserReducer: {},
    viewReducer: {},
    loadWorkItems: {},
    userProfile: initialUserProfileState,
    bannerReducer: {},
    workItemSubscriptionReducer: {},
    notificationsReducer: {},
    ratingReducer: {},
    dashboardSplitMode: false,
    maaSCreationData: initialMaaSState,
    languageReducer: {},
    gpsCreationData: initialGPSInvetmentState,
    gpsManageListData: initialGPSManageListState,
    selectedActionId: '',
    vacTenant: {},
    featureFlags: initialFeatureFlagsState,
    copilot: copilotInitialState,
    [copilotApi.reducerPath]: copilotApi.reducer(undefined, { type: '' }),
  }
}

const combinedReducers = combineReducers<StoreState>({
  dropdownData: dropdownDataReducer,
  filter: filterReducer,
  viewReducer,
  loadWorkItems,
  signedInUserReducer,
  dashboardReducer,
  actionReducer,
  userProfile: userProfileReducer,
  bannerReducer,
  workItemSubscriptionReducer,
  notificationsReducer,
  ratingReducer,
  maaSCreationData: maaSreducer,
  languageReducer,
  navCollapsedReducer,
  gpsCreationData: gpsReducer,
  gpsManageListData: gpsManageListReducer,
  vacTenant: vacTenantReducer,
  featureFlags: featureFlagsReducer,
  copilot: copilotReducer,
  [copilotApi.reducerPath]: copilotApi.reducer,
} as any);

const composeEnhancers =
  (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose) || compose;
const middleware = applyMiddleware(thunk, copilotApi.middleware, languageMiddleware);

// tslint:disable-next-line:no-any
export const store: any = createStore<StoreState, AnyAction, any, any>(
  combinedReducers,
  composeEnhancers(middleware)
);

// tslint:disable-next-line:no-any
declare const window: any;

// Export RootState for use in selectors
export type RootState = StoreState;
// Generated by GitHub Copilot | Updated on: 2026-07-21 | 4 lines added | Registered in-memory featureFlags reducer (serverDrivenForms + legacyRecompute) in the root store
